<template>
  <div style="margin: -5px 0;">
    <WarningListEntry
      v-for="warning in warnings"
      :key="warning.id"
    />
  </div>
</template>

<script>
import WarningListEntry from './WarningListEntry'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'WarningList',
  components: { WarningListEntry },
  computed: {
    ...mapGetters([
      'getStoredWarnings'
    ]),
    warnings () {
      return this.getStoredWarnings
    }
  },
  mounted () {
    this.getWarnings()
  },
  methods: {
    ...mapActions([
      'getWarnings'
    ])
  }
}
</script>

<style scoped>

</style>
